import React, { useState, useEffect } from 'react'
import { Loader } from '@wsc_sports/components-library'
import { downloadUrlInTheSameTab, fetchPlayer } from '../network'
import { ANALYTICS, initAnalytics } from '../common/wscjs/analytics'
import { logException } from '../common/wscjs/analytics'
import config from '../config'
import { getUrlParams } from './utils'
import { VideoPlayer } from './video/VideoPlayer'
import MediaContainer from './MediaContainer'
import { StyledCenterPosition, StyledLoaderWithBackground } from './StyledApp.styled'
import { StyledGif } from './gif/StyledGif.styled'

initAnalytics({
  [ANALYTICS.SENTRY]: (config as any).SENTRY_INIT,
  [ANALYTICS.FULLSTORY]: (config as any).FULLSTORY_INIT,
})

const App = (): JSX.Element => {
  const [mediaTitle, setMediaTitle] = useState<string>('')
  const [mediaUrl, setMediaUrl] = useState<string>('')
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true)
  const [isFadeIn, setIsFadeIn] = useState(true)

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const res = await fetchPlayer(getUrlParams())
        const { contentTitle, contentUrl } = await res.json()

        setMediaTitle(contentTitle)
        setMediaUrl(contentUrl)
        setIsDataLoading(false)
      } catch (error) {
        logException(error)
      }
    }

    fetchInitialData()
  }, [])

  const onClickDownload = async () => {
    try {
      const params = getUrlParams()
      const queryParams = new URLSearchParams({ ...params })
      const downloadUrl = `${config.DOWNLOAD_SERVICE}/public/redirect/?${queryParams.toString()}`

      if (downloadUrl) {
        downloadUrlInTheSameTab(downloadUrl)
      } else {
        console.error('Failed to fetch public download', downloadUrl)
      }
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  const isGif = mediaUrl.endsWith('.gif')

  if (isDataLoading) {
    return (
      <StyledLoaderWithBackground>
        <StyledCenterPosition>
          <Loader size="2.857rem" />
        </StyledCenterPosition>
      </StyledLoaderWithBackground>
    )
  }

  if (isGif) {
    return (
      <MediaContainer onClickDownload={onClickDownload} isFadeIn={true}>
        <StyledGif src={mediaUrl} alt="Animated GIF" />
      </MediaContainer>
    )
  }

  return (
    <MediaContainer onClickDownload={onClickDownload} isFadeIn={isFadeIn}>
      <VideoPlayer
        mediaSrc={mediaUrl}
        mediaTitle={mediaTitle}
        setIsFadeIn={setIsFadeIn}
        isFadeIn={isFadeIn}
      />
    </MediaContainer>
  )
}

export default App
